import { IMeetingConfirmation } from '.';

export const UserRemoteWorkTypes = {
  NONE: 'NONE',
  CAN_COME: 'CAN_COME',
  REMOTE: 'REMOTE',
};

export const UserStatusMarkers = {
  REMOTE_WORK: 'REMOTE_WORK',
  UNAVAILABLE_FOR_OTHER_REASON: 'UNAVAILABLE_FOR_OTHER_REASON',
};

export type TUserRemoteWorkTypes = typeof UserRemoteWorkTypes[keyof typeof UserRemoteWorkTypes];
export type TUserStatusMarkers = typeof UserStatusMarkers[keyof typeof UserStatusMarkers];

export interface IUser extends IUserRequest {
  img: string;
}

interface IUserLocation {
  timeZone: string;
  useLocalTimeZone: boolean;
}

export interface IUserDto extends Omit<IUser, 'username'> {
  userStateDto: IUserLocation;
}

export type TUserForMeetingPlaner = Map<number, IUserForMeetingPlaner>;

export interface IUserForMeetingPlaner extends IUser {
  isCurrentUser?: boolean;
  confirmation?: IMeetingConfirmation;
  isSelected: boolean;
}

export interface IOccupiedTime {
  start: Date;
  end: Date;
}

export interface IUserRequest {
  id: number;
  corporateEmail: string;
  fullName: string;
  position: string;
  isActive: boolean;
  remoteWorkType: TUserRemoteWorkTypes;
}

export interface IUserStatus {
  startDate: Date;
  endDate: Date;
  marker: TUserStatusMarkers;
  description: string;
}

export interface IUserStatusRequest {
  startIntervalDate: Date;
  endIntervalDate: Date;
}

export type TUserRoles = 'USER' | 'ADMIN' | 'MODERATOR' | 'SUPER_ADMIN';
